import validate from "/home/forge/app.getgreengold.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/forge/app.getgreengold.com/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/forge/app.getgreengold.com/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  protected: () => import("/home/forge/app.getgreengold.com/middleware/protected.ts"),
  "upvest-activated": () => import("/home/forge/app.getgreengold.com/middleware/upvest.activated.ts"),
  verified: () => import("/home/forge/app.getgreengold.com/middleware/verified.ts")
}